import * as S from '../../styled';

export const Icon = ({ name, width = 16, height = 16 }) => (
  <S.Image
    src={`./assets/storeV2/${name}.png`}
    alt={name}
    $width={width}
    $height={height}
  />
);
